import { useEffect, type ReactNode } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { fitnessWorkoutController } from '@/lib/fitnessWorkoutController';
import { FitnessWorkoutRuntimeManaged } from '@/lib/fitnessWorkoutRuntimeContext';

/** The controller survives route changes, but never account changes. */
export default function FitnessWorkoutRuntimeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    let alive = true, seenAuthEvent = false;
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => { seenAuthEvent = true; if (alive) fitnessWorkoutController.bindOwner(session?.user.id ?? null); });
    void supabase.auth.getSession().then(result => { if (alive && !seenAuthEvent && !result.error) fitnessWorkoutController.bindOwner(result.data.session?.user.id ?? null); }).catch(() => { /* An auth read failure cannot replace the observed owner. */ });
    return () => { alive = false; subscription.unsubscribe(); fitnessWorkoutController.bindOwner(null); fitnessWorkoutController.retire(); };
  }, []);
  return <FitnessWorkoutRuntimeManaged.Provider value>{children}</FitnessWorkoutRuntimeManaged.Provider>;
}
